module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pgo8c3ZnIGRhdGEtbmFtZT0iTGl2ZWxsbyAxIiBpZD0iTGl2ZWxsb18xIiB2aWV3Qm94PSIwIDAgMjAuNTcgMzgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGRlZnM+CiAgICA8c3R5bGU+LmNscy0xe2ZpbGw6bm9uZTtzdHJva2U6I2ZmZmZmZjtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLXdpZHRoOjRweDt9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8dGl0bGUvPgogIDxwb2x5bGluZSBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMTguNTQgMiAyIDE4Ljg2IDE4LjU3IDM2Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/modules/sidebar/assets/arrow.svg
// module id = RQrH
// module chunks = 0